import styled from 'styled-components';

const MainHolder = styled.main`
  min-height: calc(100vh - 132px);
`;

export default MainHolder;
